import { motion, Transition, Variants } from 'framer-motion';
import { ReactNode, useRef } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  skipInitialAnimation?: boolean;
}

const pageVariants: Variants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
  },
  exit: {
    opacity: 0,
    y: -20,
  },
};

const pageTransition: Transition = {
  type: 'tween',
  ease: 'anticipate' as const,
  duration: 0.4,
};

export function PageTransition({ children, skipInitialAnimation = false }: PageTransitionProps) {
  const hasAnimated = useRef(false);
  const shouldSkip = skipInitialAnimation && !hasAnimated.current;
  
  if (shouldSkip) {
    hasAnimated.current = true;
  }

  return (
    <motion.div
      initial={shouldSkip ? "animate" : "initial"}
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={pageTransition}
    >
      {children}
    </motion.div>
  );
}
